import type {SocialLinks} from "~/types";


export const socialLinks: SocialLinks = {
  // FACEBOOK: {link: "javascript:void(0);", icon: "entypo-social:facebook-with-circle"},
  INSTAGRAM: {link: "https://www.instagram.com/seurole_oficial/", icon: "hugeicons:instagram"},
  WHATSAPP: {link: "https://wa.me/554792934296", icon: "ic:baseline-whatsapp"},
  // LINKEDIN: {link: "javascript:void(0);", icon: "mingcute:linkedin-line"}
}

export const socialInfo = {
  fantasyName: "Seu Rolê Mediação de Pagamentos",
  cnpj: "61.859.240/0001-30",
  address: "Rua Dalina Rocha, nº 126 – Bairro Bremer – CEP 89161-119 – Rio do Sul/SC",
  emails: {
    contact: "contato@seurole.com.br",
    support: "suporte@seurole.com.br",
    commercial: "comercial@seurole.com.br"
  },
  phones: {
    whatsapp: "(47)99293-4296",
  }
}
